export default "__VITE_ASSET__CGaC6T$4__"